<template>
    <div class="map" :style="{ 'background': 'url( ' + image + ' ) ', backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPosition: 'center top' } ">
      <div class="container">
        <div class="row flex-vertical-align-center">
          <div class="element col-l-12 col-m-12 col-s-12">
            <div class="map__content" v-html="text">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    props: ['blockdata'],
    name: 'block-map',
    data() {
        return{
            text: this.blockdata.text,
            image: this.blockdata.image.url,
        }
    },
    mounted: function(){
    }
  }
</script>


// WEBPACK FOOTER //
// BlockMap.vue?0061b0ca